import Modal from "../Modal";
import LoanAddItemForm from "../../forms/loan/LoanAddItemForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function LoanAddItemModal({
  show,
    handleClose,
  loan_id,
  callback,
  title = null,
  loan_from,
  loan_to,
}) {
  const { t } = useTranslation();
  const defaultTitle = t("loans.addProduct");
  return (
    <Modal title={title || defaultTitle} show={show} handleClose={handleClose}>
      <LoanAddItemForm
          handleClose={handleClose}
        loan_id={loan_id}
        callback={callback}
        loan_from={loan_from}
        loan_to={loan_to}
      />
    </Modal>
  );
}
